import factory from './icon';
import Svg from './glyphs/vxn_logo.svg';

export default factory(Svg);
